const LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: [],
  latestEvent: undefined,
  data: [],
  isDirty: false,
  dataForRenaming: undefined,
  mainTreeExpandedKeys: [],
  supportingTreeExpandedKeys: [],
}

export default LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_INITIAL_STATE
